<template>
  <v-container>
    <v-layout text-xs-center wrap >

      <v-flex class="mb-5">

        <h1 class="display-2 font-weight-bold pt-4">Fresco Krooshof</h1>
        <h2 class="mb-4">visualizing your ideas</h2>
        
        <v-carousel
          :hide-delimiters=true
          >
          <v-carousel-item 
            v-for="(item,i) in items" :key="i" :src="item.src">
            <div class="caroussel-info">
              <h2 class="mt-2">{{ item.title }}</h2>
              <p>{{ item.desc }}</p>
            </div>
          </v-carousel-item>
        </v-carousel>
        
        <!-- <div class="pt-4">
       
          <p pt-2>Deze website is in ontwikkeling, <br>
              hierboven alvast een paar visualisaties <br>
              die in opdracht van
              <a href="http://www.schallwerk.nl" target="_blank">Schaalwerk</a>
              zijn gemaakt...</p>
       
        </div> -->

        <div class="connect pt-4" >
          <h2 class="mb-2">Ways to connect</h2>
          <a @click="working" target="_blank"><v-icon>mdi-phone</v-icon></a>  
          <a @click="working" target="_blank"><v-icon>mdi-email</v-icon></a>  
          <!-- <a href="#" target="_blank"><v-icon>mdi-whatsapp</v-icon></a>   -->
          <!-- <a href="https://www.facebook.com/fresco.krooshof" target="_blank"><v-icon>mdi-facebook-box</v-icon></a>  -->
          <!-- <a href="#" target="_blank"><v-icon>mdi-instagram</v-icon></a>  -->
          <!-- <a href="https://nl.pinterest.com/fkrooshof/" target="_blank"><v-icon>mdi-pinterest</v-icon></a>  -->
          <!-- <a href="https://www.deviantart.com/frescok" target="_blank"><v-icon>mdi-deviantart</v-icon></a>  -->
          <a href="https://www.linkedin.com/in/fresco-krooshof-33837a144/" target="_blank"><v-icon>mdi-linkedin-box</v-icon></a>       
        </div>


      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  // import image01 from 

  export default {
    methods: {
      working() {
        alert('Not ready yet, sorry...')
      }
    },
    data: () => ({
      items: [{
          src: require('@/assets/images/1.jpeg'),
          title: 'Down the Rabbit Hole',
          desc: 'Client: Schaalwerk'
        },
        {
          src: require('@/assets/images/2.jpeg'),
          title: 'Rembrand activatie',
          desc: 'Client: Schaalwerk'
        },
        {
          src: require('@/assets/images/3.jpeg'),
          title: 'Lamp design for a studio in Berlin',
          desc: 'Client: Schaalwerk'
        },
        // {
        //   src: require('@/assets/images/4.jpeg'),
        //   title: 'Down the Rabbit Hole',
        //   desc: 'Klant: Schaalwerk'
        // },
        // {
        //   src: require('@/assets/images/5.jpeg'),
        //   title: 'Down the Rabbit Hole',
        //   desc: 'Klant: Schaalwerk'
        // },
        // {
        //   src: require('@/assets/images/6.jpeg'),
        //   title: 'Down the Rabbit Hole',
        //   desc: 'Klant: Schaalwerk'
        // }
      ]
    })
  }
</script>

<style>

.caroussel-info {
  background-color: rgba(255,0,0,0.5); 
  color: #fff;
  top: 30px; 
  position: absolute;
  text-align: left;
  align-content: left;
  padding: 0 10px;
}
.connect a {
  text-decoration: none;
  padding: 0 5px;
  
}
</style>